import { SPOILER_TYPE } from '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const customStyleFn = (styles) => styles.toArray().reduce((cssStyle) => {
  return __spreadProps(__spreadValues({}, cssStyle), {
    filter: "blur(0.25em)",
    display: "inline"
  });
}, {});
const styleFnFilter = () => {
  return (styles) => {
    const _styles = styles.filter((style) => style === SPOILER_TYPE);
    return customStyleFn(_styles);
  };
};
const initSpoilersContentState = (contentState) => {
  let prevSpoilerStyle = "";
  const blocks = contentState.blocks.map((block) => {
    var _a;
    let isBlockContainSpoiler;
    const inlineStyleRanges = (_a = block == null ? void 0 : block.inlineStyleRanges) == null ? void 0 : _a.map((range) => {
      if (range.style === SPOILER_TYPE) {
        isBlockContainSpoiler = true;
        if (block.text.length === range.offset + range.length) {
          prevSpoilerStyle = range.offset !== 0 || prevSpoilerStyle === "" ? `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}` : prevSpoilerStyle;
        }
        return __spreadProps(__spreadValues({}, range), {
          style: range.offset === 0 && prevSpoilerStyle !== "" ? prevSpoilerStyle : `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}`
        });
      }
      return __spreadValues({}, range);
    });
    if (!isBlockContainSpoiler) {
      prevSpoilerStyle = "";
    }
    return __spreadProps(__spreadValues({}, block), {
      inlineStyleRanges
    });
  });
  return __spreadProps(__spreadValues({}, contentState), {
    blocks
  });
};

export { customStyleFn, initSpoilersContentState, styleFnFilter };
//# sourceMappingURL=spoilerUtilsFn.js.map
